import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { PartnerOnboardingEntityType } from 'vopay';

/**
 * The raw `EntityType` stays the logic key; only the rendered label is localized. Wording per spec §6.4
 * ("Account", "Sub Account", "Partner"). The keys sit at feature level (`OnboardingTracker.EntityTypeLabels`)
 * because the drawer's "{type} · Last activity" meta line shows the same three labels.
 */
export default function useEntityTypeLabels() {
  const { t } = useTranslation('translations', { keyPrefix: 'OnboardingTracker.EntityTypeLabels' });

  return useMemo(() => {
    const labelsByEntityType: Record<PartnerOnboardingEntityType, string> = {
      Partner: t('partner', { defaultValue: 'Partner' }),
      Account: t('account', { defaultValue: 'Account' }),
      SubAccount: t('subAccount', { defaultValue: 'Sub Account' }),
    };

    return {
      /** Falls back to the raw value if the backend sends a type the union doesn't know yet. */
      resolveEntityTypeLabel: (entityType: PartnerOnboardingEntityType): string =>
        labelsByEntityType[entityType] ?? entityType,
    };
  }, [t]);
}
